import React,{useState} from 'react'
import PropTypes from 'prop-types';
import {Dropdown} from 'reactstrap';
import {objectWithoutProperties,extendClass} from '../../../utils/utils'

//================ Property Value Type =====================
const propsType={
    children:PropTypes.node,
    direction:PropTypes.string
};

//================ Default Property Value =====================
const defaultProps={
    direction:'down'
};

const AppHeaderDropDown=(props)=>{
    const [dropdownIsOpen,setDropDown]=useState(false),
          children = props.children,
          attributes = objectWithoutProperties(props, 'children');

    function toggle(){
        setDropDown(!dropdownIsOpen);
    }

    return (
        React.createElement(
            Dropdown,
            extendClass({nav:true, isOpen:dropdownIsOpen,toggle:toggle},attributes),
            children
        )    
    );
}


AppHeaderDropDown.propTypes=propsType;
AppHeaderDropDown.defaultProps=defaultProps

export default AppHeaderDropDown;